import { WCCContentBlockFactory } from 'components/content/parser.interfaces';
import { IWCCContentBlock, IWCCContentBlockSplitOptions, WCCContentBlockType } from '../block/block.interfaces';

export class WCCContentContainerBlock implements IWCCContentBlock {
    blocks: IWCCContentBlock[];

    get type() {
        return this.getType();
    }

    get content() {
        return this.getContent();
    }

    get nodes() {
        return this.getNodes();
    }

    get length() {
        return this.getLength();
    }

    constructor(blocks: IWCCContentBlock[] = []) {
        this.blocks = blocks;
    }

    splitBy(options: IWCCContentBlockSplitOptions, factory: WCCContentBlockFactory): Array<IWCCContentBlock> {
        return [this.getContainer(this.blocks.flatMap(block => block.splitBy(options, factory)))];
    }

    take(length: number): IWCCContentBlock {
        return this.blocks.reduce((result, block) => {
            if (block.length < length) { 
                const newBlock = block.take(length - block.length);
                return this.getContainer([block, newBlock]);
            }

            return result;
        }, this.getContainer());
    }

    mergeWith(other: IWCCContentBlock): IWCCContentBlock | undefined {
        if (other instanceof WCCContentContainerBlock)
            return this.getContainer([...this.blocks, ...other.blocks]);

        return undefined;
    }

    optimize(prev?: IWCCContentBlock) {
        this.blocks.reduce((prevBlock, block, idx) => (block.optimize(prevBlock), block), <IWCCContentBlock | undefined>undefined);
    }

    clone() {
        return this.getContainer(this.blocks);
    }

    equals(other: IWCCContentBlock) {
        return other.constructor === this.constructor &&
            other.content === this.content;
    }

    protected getContainer(blocks?: IWCCContentBlock[]) {
        return new WCCContentContainerBlock(blocks);
    }

    protected getType(): WCCContentBlockType {
        return 'container';
    }

    protected getContent() {
        return this.blocks.reduce((result, block) => result + block.content, '');
    }

    protected getLength() {
        return this.blocks.reduce((result, block) => result + block.length, 0);
    }

    protected getNodes() {
        return this.blocks.flatMap(block => block.nodes);
    }
}